import { atom } from 'jotai';

import type { ReactNode } from 'react';

export type TCenterDialogState = {
  isOpen?: boolean;
  children?: ReactNode;
  size?: 'sm' | 'md';
  shouldCloseOnBlur?: boolean;
};

export const INITIAL_CENTER_DIALOG_STATE = {
  isOpen: false,
  children: null,
  size: 'sm',
  shouldCloseOnBlur: true,
} satisfies TCenterDialogState;

const centerDialogAtom = atom<TCenterDialogState>(INITIAL_CENTER_DIALOG_STATE);

export { centerDialogAtom };
